import {
  catalogueSummary,
  useImportCsvMutation,
} from '@/features/imports/api/use-import-csv-mutation';
import { queryKeys } from '@/lib/query-keys';
import type { ImportProductsCsvInput } from '@borradh-workspace/api-client/types';
import {
  type ImportProductsCsvResponse,
  importProductsCsvResponseSchema,
} from '@borradh-workspace/contracts';

export const useImportProductsCsv = (options?: {
  onSuccess?: (result: ImportProductsCsvResponse) => void;
  onError?: (error: Error) => void;
}) => {
  const { mutate, mutateAsync, isImporting, isSuccess, isError, error } =
    useImportCsvMutation<ImportProductsCsvInput, ImportProductsCsvResponse>({
      path: 'products/import-csv',
      schema: importProductsCsvResponseSchema,
      event: 'products_imported_csv',
      track: (r) => ({
        created: r.created,
        updated: r.updated,
        skipped: r.skipped,
        failed: r.errors.length,
      }),
      // The import can also create CATEGORIES and BRANDS, which the products
      // page renders from separate queries.
      invalidate: () => [
        queryKeys.products.all(),
        queryKeys.productCategories.all(),
        queryKeys.productBrands.all(),
      ],
      summarize: (r) => catalogueSummary({ ...r, imported: r.created }),
      onSuccess: options?.onSuccess,
      onError: options?.onError,
    });
  return {
    importProductsCsv: mutate,
    importProductsCsvAsync: mutateAsync,
    isImporting,
    isSuccess,
    isError,
    error,
  };
};
